var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-row',{style:(_vm.style),attrs:{"align":"center"}},[_c('v-col',{attrs:{"align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size,"width":_vm.width,"color":_vm.color}}),_c('div',{staticClass:"mt-6 text-h5"},[_vm._v(_vm._s(_vm.message))])],1)],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }